import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatMaxLoanAmount = (maxLoanAmount) => {
  const maxLoanAmountValue = Number(maxLoanAmount);
  if (isNaN(maxLoanAmountValue)) return '';
  const isWholeNumber = maxLoanAmountValue % 1 === 0;
  return isWholeNumber
    ? maxLoanAmountValue.toLocaleString('en-UK')
    : maxLoanAmountValue.toLocaleString('en-UK', { minimumFractionDigits: 2 });
};

export const scrollToFirstError = () => {
  // Use setTimeout to ensure DOM has updated with error styles
  setTimeout(() => {
    // Try multiple selectors to find error fields
    const errorSelectors = [
      '[class*="border-[#D32F2F]"]', // Contains the error border class
      '[class*="border-2"][class*="border-[#D32F2F]"]', // More specific selector
      'input[class*="border-[#D32F2F]"]', // Input fields with error styling
      'div[class*="border-[#D32F2F]"]', // Dropdown fields with error styling
    ];

    let firstErrorField = null;

    for (const selector of errorSelectors) {
      firstErrorField = document.querySelector(selector);
      if (firstErrorField) break;
    }

    if (firstErrorField) {
      firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Focus if it's an input element
      if (firstErrorField.tagName === 'INPUT' || firstErrorField.tagName === 'TEXTAREA') {
        firstErrorField.focus();
      }
    }
  }, 100); // Small delay to ensure DOM update
};
